import { Component, ViewChild } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { IngredientsServices } from '../../../ingredients/services';
import { TranslateService } from '@ngx-translate/core';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';

/**
 * Generated class for the IngredientCompPartialIngSelectedPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-providers-partial-ingredients-selected',
    templateUrl: 'providers-partial-ingredients-selected.html',
})
export class ProvidersPartialIngredientsSelectedPage {

    //datatable
    sorts = [
        { prop: 'name', dir: 'asc' }
    ];
    @ViewChild(DatatableComponent) table: DatatableComponent;
    ColumnMode = ColumnMode;
    config_msg = {
        emptyMessage: this.translate.instant('general-no-hay-datos'),
        totalMessage: this.translate.instant('general-total'),
        selectedMessage: this.translate.instant('general-seleccionado')
    };
    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public ingredientsServices: IngredientsServices,
        public globals: Globals,
        public translate: TranslateService) {
    }

    delete(element) {
        var index = this.ingredientsServices.provider_ingredients_array_tmp.findIndex(x => x[0] == element[0]);
        if (index >= 0) {
            this.ingredientsServices.provider_ingredients_array_tmp.splice(index, 1);
            this.ingredientsServices.provider_ingredients_array_tmp = [...this.ingredientsServices.provider_ingredients_array_tmp];
        }
    }

    clickElement(event) {
        if (event.type == 'click') {
            this.delete(event.row);
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/providers/providers-add-select-elements/providers-partial-ingredients-selected/providers-partial-ingredients-selected.ts